import { render, staticRenderFns } from "./AccountCompanies.vue?vue&type=template&id=4ccc55e6&scoped=true&"
import script from "./AccountCompanies.vue?vue&type=script&lang=js&"
export * from "./AccountCompanies.vue?vue&type=script&lang=js&"
import style0 from "./AccountCompanies.vue?vue&type=style&index=0&id=4ccc55e6&lang=scss&scoped=true&"
import style1 from "./AccountCompanies.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc55e6",
  null
  
)

export default component.exports